var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _ProductSlider_instances, setupStructure_fn, buildPagination_fn, bindNav_fn, bindArrows_fn, bindDrag_fn, setSlide_fn, applyTransform_fn, updateActiveStates_fn, autoPauseMedia_fn;
class ProductSlider extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _ProductSlider_instances);
    this.shell = this.querySelector(".slider-for");
    this.track = this.querySelector(".slider-for .swiper-wrapper");
    this.slides = Array.from(this.querySelectorAll(".slider-for .swiper-slide"));
    this.paginationEl = this.querySelector(".slider-for .swiper-pagination");
    this.navShell = this.querySelector(".slider-nav");
    this.navTrack = this == null ? void 0 : this.querySelector(".slider-nav .swiper-wrapper");
    this.navSlides = this ? Array.from(this.querySelectorAll(".slider-nav .swiper-slide")) : [];
    this.btnPrev = this == null ? void 0 : this.querySelector(".slider-nav .swiper-button-prev");
    this.btnNext = this == null ? void 0 : this.querySelector(".slider-nav .swiper-button-next");
    this.index = 0;
    this.total = this.slides.length;
    this.dragging = false;
    this.startX = 0;
    this.currentX = 0;
    this.deltaX = 0;
    this.thresholdPx = 50;
    this.loop = true;
  }
  connectedCallback() {
    var _a;
    if (!this.track || this.total === 0) return;
    __privateMethod(this, _ProductSlider_instances, setupStructure_fn).call(this);
    __privateMethod(this, _ProductSlider_instances, buildPagination_fn).call(this);
    __privateMethod(this, _ProductSlider_instances, bindNav_fn).call(this);
    __privateMethod(this, _ProductSlider_instances, bindArrows_fn).call(this);
    __privateMethod(this, _ProductSlider_instances, bindDrag_fn).call(this);
    __privateMethod(this, _ProductSlider_instances, setSlide_fn).call(this, 0, false);
    this.setAttribute("role", "region");
    this.setAttribute("aria-label", "Product media gallery");
    (_a = this.shell) == null ? void 0 : _a.setAttribute("aria-roledescription", "carousel");
    this._onResize = () => __privateMethod(this, _ProductSlider_instances, applyTransform_fn).call(this);
    window.addEventListener("resize", this._onResize, { passive: true });
  }
  disconnectedCallback() {
    window.removeEventListener("resize", this._onResize);
  }
  // ----- Public controls -----------------------------------------------------
  next() {
    const last = this.total - 1;
    if (this.index === last) {
      if (!this.loop) return __privateMethod(this, _ProductSlider_instances, setSlide_fn).call(this, last);
      __privateMethod(this, _ProductSlider_instances, setSlide_fn).call(this, 0);
    } else {
      __privateMethod(this, _ProductSlider_instances, setSlide_fn).call(this, this.index + 1);
    }
  }
  prev() {
    if (this.index === 0) {
      if (!this.loop) return __privateMethod(this, _ProductSlider_instances, setSlide_fn).call(this, 0);
      __privateMethod(this, _ProductSlider_instances, setSlide_fn).call(this, this.total - 1);
    } else {
      __privateMethod(this, _ProductSlider_instances, setSlide_fn).call(this, this.index - 1);
    }
  }
}
_ProductSlider_instances = new WeakSet();
// ----- Setup --------------------------------------------------------------
setupStructure_fn = function() {
  Object.assign(this.shell.style, {
    position: "relative",
    overflow: "hidden",
    touchAction: "pan-y"
    // allow vertical scroll
  });
  Object.assign(this.track.style, {
    display: "flex",
    willChange: "transform",
    transition: "transform 300ms ease"
  });
  this.slides.forEach((s, i) => {
    s.setAttribute("role", "group");
    s.setAttribute("aria-roledescription", "slide");
    s.setAttribute("aria-label", `${i + 1} of ${this.total}`);
    s.style.flex = "0 0 100%";
    s.style.maxWidth = "100%";
    s.style.userSelect = "none";
    s.querySelectorAll("img").forEach((img) => {
      img.draggable = false;
    });
  });
  if (this.navShell && this.navTrack) {
    Object.assign(this.navTrack.style, {
      display: "flex",
      gap: "8px",
      flexWrap: "wrap"
    });
    this.navSlides.forEach((ns) => {
      ns.style.cursor = "pointer";
    });
  }
};
buildPagination_fn = function() {
  if (!this.paginationEl) return;
  this.paginationEl.innerHTML = "";
  const frag = document.createDocumentFragment();
  this.dots = this.slides.map((_, i) => {
    const b = document.createElement("button");
    b.type = "button";
    b.className = "ps-dot";
    b.setAttribute("aria-label", `Go to slide ${i + 1}`);
    Object.assign(b.style, {
      width: "8px",
      height: "8px",
      borderRadius: "50%",
      border: "0",
      margin: "0 4px",
      background: "rgba(0,0,0,.25)"
    });
    b.addEventListener("click", () => __privateMethod(this, _ProductSlider_instances, setSlide_fn).call(this, i));
    frag.appendChild(b);
    return b;
  });
  Object.assign(this.paginationEl.style, {
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    padding: "10px 0"
  });
  this.paginationEl.appendChild(frag);
};
bindNav_fn = function() {
  var _a;
  if (!((_a = this.navSlides) == null ? void 0 : _a.length)) return;
  this.navSlides.forEach((el, i) => {
    el.addEventListener("click", () => __privateMethod(this, _ProductSlider_instances, setSlide_fn).call(this, i));
    el.tabIndex = 0;
    el.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        __privateMethod(this, _ProductSlider_instances, setSlide_fn).call(this, i);
      }
    });
  });
};
bindArrows_fn = function() {
  var _a, _b;
  (_a = this.btnPrev) == null ? void 0 : _a.addEventListener("click", () => this.prev());
  (_b = this.btnNext) == null ? void 0 : _b.addEventListener("click", () => this.next());
};
bindDrag_fn = function() {
  const start = (clientX) => {
    this.dragging = true;
    this.startX = clientX;
    this.deltaX = 0;
    this.track.style.transition = "none";
  };
  const move = (clientX) => {
    if (!this.dragging) return;
    this.currentX = clientX;
    this.deltaX = this.currentX - this.startX;
    __privateMethod(this, _ProductSlider_instances, applyTransform_fn).call(this, this.deltaX);
  };
  const end = () => {
    if (!this.dragging) return;
    this.dragging = false;
    this.track.style.transition = "transform 300ms ease";
    if (Math.abs(this.deltaX) > this.thresholdPx) {
      if (this.deltaX < 0) this.next();
      else this.prev();
    } else {
      __privateMethod(this, _ProductSlider_instances, applyTransform_fn).call(this, 0);
    }
  };
  this.shell.addEventListener("mousedown", (e) => start(e.clientX));
  window.addEventListener("mousemove", (e) => move(e.clientX));
  window.addEventListener("mouseup", end);
  this.shell.addEventListener("touchstart", (e) => start(e.touches[0].clientX), { passive: true });
  this.shell.addEventListener("touchmove", (e) => move(e.touches[0].clientX), { passive: true });
  this.shell.addEventListener("touchend", end);
  this.shell.addEventListener("touchcancel", end);
  this.shell.tabIndex = 0;
  this.shell.addEventListener("keydown", (e) => {
    if (e.key === "ArrowRight") this.next();
    if (e.key === "ArrowLeft") this.prev();
  });
};
// ----- Core ---------------------------------------------------------------
setSlide_fn = function(i, animate = true) {
  this.index = Math.max(0, Math.min(i, this.total - 1));
  if (!animate) this.track.style.transition = "none";
  __privateMethod(this, _ProductSlider_instances, applyTransform_fn).call(this, 0);
  if (!animate) {
    this.track.offsetHeight;
    this.track.style.transition = "transform 300ms ease";
  }
  __privateMethod(this, _ProductSlider_instances, updateActiveStates_fn).call(this);
  __privateMethod(this, _ProductSlider_instances, autoPauseMedia_fn).call(this);
};
applyTransform_fn = function(extraDelta = 0) {
  const offset = -(this.index * this.shell.clientWidth) + extraDelta;
  this.track.style.transform = `translate3d(${offset}px,0,0)`;
};
updateActiveStates_fn = function() {
  var _a, _b;
  this.slides.forEach((s, idx) => {
    const active = idx === this.index;
    s.classList.toggle("is-active", active);
    s.setAttribute("aria-hidden", active ? "false" : "true");
    s.tabIndex = active ? 0 : -1;
  });
  if ((_a = this.dots) == null ? void 0 : _a.length) {
    this.dots.forEach((d, idx) => {
      const active = idx === this.index;
      d.style.background = active ? "rgba(0,0,0,.85)" : "rgba(0,0,0,.25)";
      d.classList.toggle("is-active", active);
    });
  }
  if ((_b = this.navSlides) == null ? void 0 : _b.length) {
    this.navSlides.forEach((t, idx) => {
      t.classList.toggle("is-active", idx === this.index);
      t.setAttribute("aria-current", idx === this.index ? "true" : "false");
    });
  }
};
autoPauseMedia_fn = function() {
  this.slides.forEach((s, idx) => {
    const vids = s.querySelectorAll("video, model-viewer");
    vids.forEach((v) => {
      if (idx !== this.index) {
        if (v.pause) v.pause();
        if (v.stop) v.stop();
      } else {
        if (v.autoplay && v.play) {
          try {
            v.play();
          } catch (e) {
          }
        }
      }
    });
  });
};
window.customElements.define("product-slider", ProductSlider);
